import { app } from '../../bootstrap/core';
import { FeatureFlagService } from './featureFlags.service';
import { WalkMeSnippetService } from './snippet/walkme.snippet';
import { FeatureFlagNames } from './featureFlags';

app.service('featureFlagService', FeatureFlagService);
app.service('walkMeSnippetService', WalkMeSnippetService);
app.constant('FeatureFlagNames', FeatureFlagNames);
